import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a73bc062"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = {
  key: 1,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["lazy-image", {'is-loading': !$setup.active}])
  }, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        ($setup.active)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: _normalizeClass(["image", $setup.orientationClass]),
              src: $setup.props.src,
              alt: $props.alt,
              draggable: "false"
            }, null, 10, _hoisted_1))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading..."))
      ]),
      _: 1
    })
  ], 2))
}